export default {
    USER_EMAIL_SIGNATURE_WRITE: 'user.email_signature:write',
    USER_EMAIL_SIGNATURE_READ: 'user.email_signature:read',
    USER_QUICK_NOTE_WRITE: 'user.quick_note:write',
    CORE_USER_READ: 'core.user:read',
    CORE_USER_WRITE: 'core.user:write',
};
